// Return tracking data in format
// [ 'trackEvent', 'Category', 'Action', 'Name', 'Value' ]

// Figma comment #1
export const headerClickLogo = ['trackEvent', 'Header', 'Click Logo']

// Figma comment #2
export const headerClickTest = ['trackEvent', 'Header', 'Click Test']

// Figma comment #3
export const headerClickActions = ['trackEvent', 'Header', 'Click Actions']

// Figma comment #4
export const headerClickClassements = [
  'trackEvent',
  'Header',
  'Click Classements',
]

// Figma comment #5
export const headerClickProfil = ['trackEvent', 'Header', 'Click Profil']

// Figma comment #6
export const headerClickCtaCommencer = [
  'trackEvent',
  'Header',
  'Click CTA',
  'Click Passer le test',
]

// Figma comment #6
export const headerClickCtaReprendre = [
  'trackEvent',
  'Header',
  'Click CTA',
  'Click Reprendre mon test',
]

// Figma comment #6
export const headerClickCtaResultats = [
  'trackEvent',
  'Header',
  'Click CTA',
  'Click Voir les résultats',
]

// Figma comment #7
export const headerClickOrganisation = [
  'trackEvent',
  'Header',
  'Click Organisation',
]

// Figma comment #8
export const footerClickLogo = ['trackEvent', 'Footer', 'Click Logo']

// Figma comment #9
export const footerClickNouveautes = [
  'trackEvent',
  'Footer',
  'Click Nouveautés',
]

// Figma comment #10
export const footerClickQuiSommesNous = [
  'trackEvent',
  'Footer',
  'Click Qui sommes-nous',
]

// Figma comment #11
export const footerClickBlog = ['trackEvent', 'Footer', 'Click Blog']

// Figma comment #12
export const footerClickDocumentation = [
  'trackEvent',
  'Footer',
  'Click Documentation',
]

// Figma comment #13
export const footerClickAmbassadeurs = [
  'trackEvent',
  'Footer',
  'Click Ambassadeurs',
]

export const footerClickFAQ = ['trackEvent', 'Footer', 'Click FAQ']

export const footerClickContact = ['trackEvent', 'Footer', 'Click Contact']

export const footerClickDiffusion = ['trackEvent', 'Footer', 'Click Diffusion']

// Figma comment #14
export const footerClickPlanSite = [
  'trackEvent',
  'Footer',
  'Click Plan du site',
]

// Figma comment #15
export const footerClickOrganisations = [
  'trackEvent',
  'Footer',
  'Click Organisations',
]

// Figma comment #16
export const footerClickInternational = [
  'trackEvent',
  'Footer',
  'Click International',
]

export const footerClickImpactco2 = ['trackEvent', 'Footer', 'Click Impact CO2']

// Figma comment #17
export const footerClickLanguage = (locale: string) => [
  'trackEvent',
  'Footer',
  'Click Language',
  `Click Language ${locale}`,
]

// Figma comment #18
export const breadcrumbClickLink = ['trackEvent', 'Breadcrumb', 'Click link']
